export default {
  GET_TEMPLATES: 'GET_TEMPLATES',
  GET_TEMPLATES_DONE: 'GET_TEMPLATES_DONE',
  TEMPLATES_ERROR: 'TEMPLATES_ERROR'
}
